import React from "react";
import { NavLink } from "react-router-dom";
import { LOGO_SRC } from "../constants/brand";

export default function Navbar() {
  return (
    <header className="navbar">
      <div className="navbar-inner">
        <NavLink to="/" className="navbar-brand" end aria-label="ChillnPark home">
          <img
            src={LOGO_SRC}
            alt="ChillnPark"
            className="navbar-logo"
            width={140}
            height={29}
          />
        </NavLink>
        <nav className="navbar-links" aria-label="Main">
          <NavLink
            to="/privacy_policy"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to="/support"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Support
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
